<template>
  <div class="details">
      <!-- 任务详情 -->
      
  </div>
</template>

<script>
export default {
    name:"details",
    data(){
        return{
            pdf_md5:this.$route.query.pdf_md5,
        }
    },
    created(){
        this.detailsInfo()
    },
    methods: {
        detailsInfo(){
            this.$http({
                url:"api/download",
                method:"GET",
                headers: {
                    'Content-Type': 'multipart/form-data'
                },
                params:{
                    pdf_md5:this.pdf_md5,
                    organ_name:localStorage.getItem("organ_name")
                }
            }).then(res=>{
                console.log(res)
            })
        }
        
    },
}
</script>

<style lang="scss" scoped>

</style>